import React from "react";

const ServicesTwoAbout = () => {
  return (
    <>
      <section className="about-area pt-120 pb-90">
        <div className="container">
          <div className="row ">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="section-title section-title-m-0 mb-30 pos-rel text-end">
                <div className="section-icon">
                  <img
                    className="section-back-icon back-icon-right"
                    src="img/section/section-back-icon.png"
                    alt=""
                  />
                </div>
                <div className="section-text section-text-small pos-rel">
                  <h5>Vaš pouzdani partner u zdravstvu i distribuciji</h5>
                  <h1>Inovativna rješenja za vaše poslovanje</h1>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="facalty-text mb-30">
                <p>
                  Biotega je posvećena pružanju usluga koje nadmašuju očekivanja
                  klijenata. Naša ponuda obuhvata sve što vam je potrebno za
                  uspješno poslovanje na tržištu – od efikasne distribucije i
                  logistike do pružanja stručne regulatorne podrške. Posebnu
                  pažnju posvećujemo analizi tržišta i prilagodbi strategija
                  kako bismo osigurali optimalne rezultate za vaše proizvode. S
                  našim inovativnim pristupom i detaljno osmišljenim procesima,
                  pomažemo kompanijama da postignu konkurentsku prednost na
                  dinamičnom tržištu zapadnog Balkana.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesTwoAbout;
